"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeriesLabel = void 0;
var react_1 = __importDefault(require("react"));
var model_1 = require("./model");
function SeriesLabel(props) {
    var seriesType = props.seriesType, x = props.x, y = props.y, color = props.color, value = props.value;
    switch (seriesType) {
        case model_1.SeriesType.Line:
            return (react_1.default.createElement("text", { x: x, y: y, dy: -9, style: { fill: color }, textAnchor: 'middle' }, value));
    }
}
exports.SeriesLabel = SeriesLabel;
//# sourceMappingURL=SeriesLabel.js.map